import { LocalCacheService } from './../../shared/services/local-cache.service';
import { environment } from './../../../environments/environment';
import { RegisterComponent } from './../../shared/components/register/register.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { IsAuthorized } from './../../shared/ngxs/action/account.action';
import { AccountState } from './../../shared/ngxs/state/account.state';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';

import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { LogInComponent } from '../../shared/components/log-in/log-in.component';
import { InstructionsComponent } from '../../shared/components/instructions/instructions.component';
import { WelcomeAboardComponent } from 'src/app/shared/components/welcome-aboard/welcome-aboard.component';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { FilterBuildings } from 'src/app/shared/ngxs/action/building.action';
import { BuildingFilterModel } from 'src/app/shared/models/building-filter.model';
import { FilterService } from 'src/app/shared/services/filter.service';
import { LanguageType } from 'src/app/shared/models/enum.model';
import {
  BuildingState,
  BuildingStateModel,
} from 'src/app/shared/ngxs/state/building.state';
import { GetDashboard } from 'src/app/shared/ngxs/action/dashboard.action';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements OnInit, OnDestroy, AfterViewChecked {
  sideBarOpen = true;
  subscription = new Subscription();

  @Select(AccountState.isAuthorized)
  isAuthorized$: Observable<boolean>;

  @Select(AccountState.pageTitle)
  pageTitle$: Observable<string>;

  @Select(BuildingState.filter)
  filter$: Observable<BuildingFilterModel>;

  currentFilter: BuildingFilterModel;

  relihUrl = environment.relihUrl;
  habitatUrl = environment.habitatUrl;

  mailTo = environment.mailto;

  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private localizationService: LocalizationService,
    private localCacheService: LocalCacheService,
    private store: Store,
    private filterService: FilterService
  ) {}

  isAuthorized = false;
  language = '';

  ngOnInit(): void {
    this.language = this.translateService.getDefaultLang();
    this.currentFilter = new BuildingFilterModel(
      [],
      [],
      '',
      '',
      [],
      0,
      0,
      LanguageType[this.language.toUpperCase()]
    );
    this.subscribeEvents();

    const welcomeAboardShown = this.localCacheService.get('welcome-aboard');

    if (!(welcomeAboardShown && welcomeAboardShown.value == 'true')) {
      this.showWelcomeModal();
    }
  }

  showContact() {
    location.href = `mailto:${this.mailTo}`;
  }

  subscribeEvents() {
    this.subscription.add(
      this.isAuthorized$.subscribe((x) => {
        this.isAuthorized = x;
      })
    );

    this.subscription.add(
      this.filter$.subscribe((x) => {
        this.currentFilter = x;
      })
    );
  }

  sideBarToggler(event: any) {
    this.sideBarOpen = !this.sideBarOpen;
  }

  showMap() {
    this.router.navigate([`/`]);
  }

  showWelcomeModal() {
    if (!this.isAuthorized) {
      const dialogRef = this.dialog.open(WelcomeAboardComponent, {
        panelClass: 'my-dialog',
      });
    }
  }

  showLogin() {
    const dialogRef = this.dialog.open(LogInComponent, {});
  }

  showRegister() {
    const dialogRef = this.dialog.open(RegisterComponent, {});
  }

  showInstruction() {
    const dialogRef = this.dialog.open(InstructionsComponent, {});
  }

  switchLang(lang: string) {
    this.localizationService.setLanguage(lang);
    this.language = lang;
    // total
    this.store.dispatch(new GetDashboard(this.language));
    this.store.dispatch(
      new FilterBuildings(
        this.filterService.generateHttpParams(),
        new BuildingFilterModel(
          this.currentFilter.municipalities,
          this.currentFilter.periods,
          this.currentFilter.street,
          this.currentFilter.streetNumber,
          this.currentFilter.types,
          this.currentFilter.searchLatitude,
          this.currentFilter.searchLongitude,
          LanguageType[lang.toUpperCase()]
        )
      )
    );
  }

  getLanguages() {
    return this.translateService.getLangs();
  }

  getFlagClass(item) {
    if (item?.toLowerCase() == 'mk') {
      return 'fi fi-mk flag-icon';
    } else {
      return 'fi fi-us flag-icon';
    }
  }

  currentLanguge() {
    return this.translateService.currentLang;
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
